import { Directive, ElementRef, EventEmitter, Output, AfterViewInit } from '@angular/core';
import { AppSettings } from './../app.settings';
import { CommonBindingDataService } from '../services/common-binding-data.service';

declare const google: any;

@Directive({
  selector: '[appSearchLocation]',
  standalone: true
})
export class SearchLocationDirective implements AfterViewInit {
  @Output() setAddress: EventEmitter<any> = new EventEmitter();
  private elem: HTMLElement;
  autocomplete: any;

  constructor(private el: ElementRef, private cs: CommonBindingDataService) {
    this.elem = el.nativeElement;
  }

  ngAfterViewInit() {
    if (typeof google !== 'undefined' && google.maps && google.maps.places) {
      this.initAutocomplete();
      this.elem.addEventListener('blur', this.handleBlur.bind(this));
      this.elem.addEventListener('input', this.handleInput.bind(this));
    }
  }

  private initAutocomplete() {
    // const center = { lat: 50.064192, lng: -130.605469 };

    const options = {
      componentRestrictions: { country: AppSettings.SUPPORTED_COUNTRY },
      fields: ["formatted_address", "geometry", "name"],
      strictBounds: false,
    };

    const input = this.elem;
    this.autocomplete = new google.maps.places.Autocomplete(input, options);
    this.autocomplete.setComponentRestrictions({ country: AppSettings.SUPPORTED_COUNTRY });

    google.maps.event.addListener(this.autocomplete, 'place_changed', () => {
      const place = this.autocomplete.getPlace();
      const fullAddress = `${place.name}, ${place.formatted_address}`;
      const placeObj = {
        name: place.name,
        address: fullAddress,
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
        id: input.id
      };
      this.invokeEvent(placeObj);
    });
  }

  private invokeEvent(place: object) {
    this.setAddress.emit(place);
  }

  private handleBlur() {
    const inputElement = this.elem as HTMLInputElement;
    setTimeout(() => {
      if (!this.autocomplete.getPlace() && inputElement.value.trim().length > 0) {
        this.setAddress.emit({ error: this.cs.getLabel('manage_locations.location_error') });
      }
    }, 100);
  }

  private handleInput() {
    const inputElement = this.elem as HTMLInputElement;
    if (!this.autocomplete.getPlace() && inputElement.value.trim().length > 0) {
      this.setAddress.emit({ error: this.cs.getLabel('manage_locations.location_error') });
    } else if (inputElement.value.trim().length === 0) {
      this.setAddress.emit({ error: this.cs.getLabel('manage_locations.location_error') });
    } else {
      this.setAddress.emit({ error: this.cs.getLabel('manage_locations.location_error') });
    }
  }

}